// extracted by mini-css-extract-plugin
export const site = "layout-module--site--3zFpa";
export const content = "layout-module--content--1WD_k";